module.exports = __webpack_public_path__ + "static/media/snapchat.21702a0b.svg";